import { authenticatedFetch } from './request';

export default async function getPageContent(setErrorMessage) {
    const onError = () => setErrorMessage && setErrorMessage('No se puede obtener el contenido de la página.');

    return await authenticatedFetch('/page-content/getList', onError);
}
